import { AssignedRole } from './data/assignedRole';
import { Company } from './data/company';
import { DeviceAlertType } from './data/deviceAlert';
import { EntityRelationship } from './data/entityRelationship';
import { Role } from './data/role';
import { User } from './data/user';

export type Location = Components.Schemas.Location;
export type EventHistory = Components.Schemas.EventHistory;
export type EditPropertyRequestBody =
	Components.RequestBodies.EditPropertyRequestBody;
export type EditDeviceRequestBody =
	Components.RequestBodies.EditDeviceRequestBody;
export type CreatePropertyRequestBody =
	Components.RequestBodies.CreatePropertyRequestBody;
export type AccessReportRecord = Components.Schemas.AccessReportRecord;
export type AccessReportExportStatus =
	Components.Schemas.AccessReportExportStatus;
export type AccessReportExportStart =
	Components.Schemas.AccessReportExportStart;
export type KeyDetectionReportRecord =
	Components.Schemas.KeyDetectionReportRecord;
export type InventoryReportRecord = Components.Schemas.InventoryReportRecord;
export type PropertyReportRecord = Components.Schemas.PropertyReportRecord;
export type CodeGenReport = Components.Schemas.CodeGenReportRecord;
export type UsageReport = Components.Schemas.CompanyUsageReport;
export type CountryAvailableSms = Components.Schemas.CountryAvailableSms;
export type MapData = Components.Schemas.MapData;
export type DashboardSettings = Components.Schemas.DashboardSettings;
export type UserNotificationPreferencesResponse =
	Components.Schemas.UserNotificationPreferencesResponse;
export type UserDeviceGroup = Components.Schemas.UserDeviceGroup;
export type UpdateUserNotificationPreferencesRequestBody =
	Components.RequestBodies.UpdateUserNotificationPreferencesRequestBody;

export interface TableColumn {
	header: string;
	dataKey: string;
	filterKey?: string;
	position?: 'right' | 'left' | 'center';
	isSortable?: boolean;
	isFilterable?: boolean;
	filterType?: string;
	filterOptions?: {
		label: string;
		value: string;
		defaultValue: boolean;
	}[];
}

export interface SelectOption<T> {
	label: string;
	value: T;
}

export interface GeoCoordinates {
	latitude: number;
	longitude: number;
}

export interface DeviceAlert {
	id: number;
	deviceId: number;
	serialNumber: string;
	deviceAlertTypeId: number;
	deviceAlertType: DeviceAlertType;
	utcTriggerTime: string;
	utcResolutionTime: string;
	propertyName: string;
	location: string;
}

export interface Property {
	propertyName: string;
	propertyId: string;
	streetName: string;
	townCity: string;
	stateProvince: string;
	zipPostalCode: string;
	propertyStatus: string;
	client: {
		id: number;
		name: string;
	};
	deviceId: string;
	lockboxSerialNumber: string;
	geoCoordinates?: GeoCoordinates;
	utcRecalibrationRequested?: string;
	utcRecalibrationPerformed?: string;
	utcRemovalRequested?: string;
}

export interface DeviceAccessHistory {
	propertyName: string;
	streetName: string;
	townCity: string;
	stateProvince: string;
	zipPostalCode: string;
	userFirstName: string;
	userLastName: string;
	workingForClientContractor: string;
	accessType: string;
	accessStartDate: string;
	accessEndDate: string;
}

export interface Contractor {
	entityId: string;
	contractorName: string;
	contractorReferenceId: string;
	streetName: string;
	townCity: string;
	stateProvince: string;
	zipPostalCode: string;
	clients: [
		{
			id: number;
			name: string;
		},
	];
	entityType: string;
	status: string;
}

export interface PendingLockBox {
	id: string;
	name: string;
	install_date: any;
}

export interface LockBox {
	id: string;
	name: string;
	progress: string;
}

export interface Client {
	clientId: string;
	name: string;
	referenceTag: string;
	clientTypeName: string;
	streetName: string;
	townCity: string;
	stateProvince: string;
	zipPostalCode: string;
	country: string;
	userCount: number;
	status: string;
	servicesLevel: string;
	specialBillingConsiderations: string;
	clientType: ClientType[];
	billingFrequency: string;
	accountManager?: string;
	mainContact?: {
		name?: string;
		email?: string;
		mobilePhoneNumber?: string;
	};
}

export interface EditClientRequestBody {
	streetName: string;
	townCity: string;
	stateProvince: string;
	zipPostalCode: string;
	clientId?: string;
	country: string;
	clientTypeId: number;
	accountManager?: string;
	mainClientContact?: {
		name?: string;
		mobilePhoneNumber?: string;
		email?: string;
	};
	status: string;
	servicesLevel: string;
	billingFrequency?: string;
	specialBillingConsiderations: string;
	referenceTag: string;
}

export interface UserProfile {
	user: User;
	availableAssignedRoles: AssignedRole[];
	activeRoleDetails?: {
		entityRelationship: EntityRelationship;
		role: Role;
		company: Company;
	};
}

export interface UserAccessHistory {
	propertyName: string;
	propertyOwner: string;
	clients: [
		{
			id: number;
			name: string;
		},
	];
	deviceId: string;
	accessType: string;
	accessStartDate: string;
	accessEndDate: string;
	accessDuration: string;
}

export interface ClientType {
	id: number;
	sequenceNumber: number;
	name: string;
}

export enum Mode {
	create,
	edit,
	viewOnly,
}
